import { useEffect, useRef, useState } from 'react';
import EcoImg from 'eco-design/base/eco-img';
import { Swiper, SwiperSlide } from 'swiper/react';
import classNames from 'classnames';
import { useWebpOrJpg } from '../../hooks/useWebpOrJpg';
import css from './index.module.scss';
import gtm from '@/utils/gtm';
import { useLang } from '@/i18n';

const IButton: React.FC<{
    url: string;
    hideUrl: string;
    onChange: () => any;
    active: boolean;
    webpOrJpg: any;
    dataId: string;
}> = ({ url, hideUrl, onChange, active, webpOrJpg, dataId }) => {
    const [ani, setAni] = useState(true);
    const handleClick = () => {
        setAni(false);
        onChange?.();
    };
    return (
        <div className={`btn-item btn-item-${dataId}  ${active ? '' : 'hide'} GtmModuleData-btn-text`} data-btn-id={dataId} onClick={handleClick}>
            <div className="bg" style={{ '--bg-img': `url(${active ? url : hideUrl})` }}></div>
            {ani && <div className="btn"></div>}
            {active && <img className="btn-img" src={webpOrJpg('https://websiteoss.ecoflow.com/upload/image/1758333020510/btn.svg')} loading="lazy" />}
        </div>
    );
};

const C: React.FC = () => {
    const { t } = useLang('shp3');
    const [isM, setIsM] = useState(false);
    const webpOrJpg = useWebpOrJpg('#shp3-C');
    const [btnActive, setBtnActive] = useState({
        a: true,
        b: true,
        c: true,
    });
    const { a, b, c } = btnActive;
    const imgList = [
        {
            jpg: 'https://websiteoss.ecoflow.com/upload/image/1760414287911/abc.jpg',
            webp: 'https://websiteoss.ecoflow.com/upload/image/1760421202034/abc.webp',
            flag: !a && !b && !c,
        },
        {
            jpg: 'https://websiteoss.ecoflow.com/upload/image/1760500108655/a.jpg',
            webp: 'https://websiteoss.ecoflow.com/upload/image/1760500109289/a.webp',
            flag: !a && b && c,
        },
        {
            jpg: 'https://websiteoss.ecoflow.com/upload/image/1760500108883/b.jpg',
            webp: 'https://websiteoss.ecoflow.com/upload/image/1760500108274/b.webp',
            flag: a && !b && c,
        },
        {
            jpg: 'https://websiteoss.ecoflow.com/upload/image/1760414287558/c.jpg',
            webp: 'https://websiteoss.ecoflow.com/upload/image/1760421200935/c.webp',
            flag: a && b && !c,
        },
        {
            jpg: 'https://websiteoss.ecoflow.com/upload/image/1760414286227/ab.jpg',
            webp: 'https://websiteoss.ecoflow.com/upload/image/1760421202294/ab.webp',
            flag: !a && !b && c,
        },
        {
            jpg: 'https://websiteoss.ecoflow.com/upload/image/1760414286727/ac.jpg',
            webp: 'https://websiteoss.ecoflow.com/upload/image/1760421201759/ac.webp',
            flag: !a && b && !c,
        },
        {
            jpg: 'https://websiteoss.ecoflow.com/upload/image/1760414361532/bc.jpg',
            webp: 'https://websiteoss.ecoflow.com/upload/image/1760421201145/bc.webp',
            flag: a && !b && !c,
        },
    ];

    useEffect(() => {
        if (typeof window === 'undefined') return;
        setIsM(window.innerWidth < 1024);
    }, []);

    const infoRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (!infoRef.current) return;
        const classArr = ['.label-ani', '.title-ani', '.desc-ani'];
        const ani1 = AniContainer.create({
            triggerElement: infoRef.current,
            triggerHook: 1,
            offset: '20%',
            duration: '100%',
            onEnter: () => {
                classArr.forEach((item) => {
                    const dom = infoRef.current?.querySelector(item);
                    if (dom) {
                        dom.classList.add('enter');
                    }
                });
            },
            onProcess: (process: number) => {
                if (process <= 0) {
                    classArr.forEach((item) => {
                        const dom = infoRef.current?.querySelector(item);
                        if (dom) {
                            dom.classList.remove('enter');
                        }
                    });
                }
            },
        });
        return () => {
            ani1.destroy?.();
        };
    }, []);
    return (
        <section className={`${css.section} shp3-C GtmModuleData-section`} id="shp3-C" data-section-id={'shp3-C'} data-section-title={t('C_title')}>
            <div className="box">
                <div className="info" ref={infoRef}>
                    <div className="label-ani ani-1">
                        <p className={`label `}>{t('C_label')}</p>
                    </div>
                    <div className="title-ani ani-2">
                        <p className={`title  `}>{t('C_title')}</p>
                    </div>
                    <div className="desc-ani ani-3 ">
                        <p className={`desc `}>
                            {t.rich('C_desc', {
                                h: (v: string) => <span className="highlight">{v}</span>,
                            })}
                        </p>
                    </div>
                </div>
            </div>
            <ul className="imgs">
                <li className={`img`}>
                    <EcoImg
                        pc={webpOrJpg(
                            'https://websiteoss.ecoflow.com/upload/image/1760067792034/I_bg.jpg',
                            'https://websiteoss.ecoflow.com/upload/image/1760068515293/I_bg.webp',
                        )}
                        h5={webpOrJpg(
                            'https://websiteoss.ecoflow.com/upload/image/1760079444979/m_bg.jpg',
                            'https://websiteoss.ecoflow.com/upload/image/1760079446785/m_bg.webp',
                        )}
                    />
                    {isM ? (
                        <>
                            <EcoImg
                                className={`btn-d-light ${btnActive.a ? 'hide' : ''}`}
                                pc={webpOrJpg(
                                    'https://websiteoss.ecoflow.com/upload/image/1760079447573/m_lb.jpg',
                                    'https://websiteoss.ecoflow.com/upload/image/1760079447267/m_lb.webp',
                                )}
                            />
                            <EcoImg
                                className={`btn-d-tv ${btnActive.b ? 'hide' : ''}`}
                                pc={webpOrJpg(
                                    'https://websiteoss.ecoflow.com/upload/image/1760079446416/m_rb.jpg',
                                    'https://websiteoss.ecoflow.com/upload/image/1760079446025/m_rb.webp',
                                )}
                            />
                            <EcoImg
                                className={`btn-d-water ${btnActive.c ? 'hide' : ''}`}
                                pc={webpOrJpg(
                                    'https://websiteoss.ecoflow.com/upload/image/1760083531142/m_lt.jpg',
                                    'https://websiteoss.ecoflow.com/upload/image/1760083668496/m_lt.webp',
                                )}
                            />
                        </>
                    ) : (
                        imgList.map((i, idx) => (
                            <EcoImg
                                className={classNames('img-item', {
                                    active: i.flag,
                                })}
                                pc={webpOrJpg(i.jpg, i.webp)}
                                key={idx}
                            />
                        ))
                    )}
                    <div className="phone15">
                        <EcoImg
                            className="phone15-mask"
                            pc={webpOrJpg(
                                'https://websiteoss.ecoflow.com/upload/image/1760067792431/I_phone.png',
                                'https://websiteoss.ecoflow.com/upload/image/1760068556685/I_phone.webp',
                            )}
                        />
                        {isM ? (
                            <Swiper className="btn-list" slidesPerView={'auto'} spaceBetween={16}>
                                <SwiperSlide>
                                    <IButton
                                        url={webpOrJpg('https://websiteoss.ecoflow.com/upload/image/1761035144634/1.png')}
                                        hideUrl={webpOrJpg('https://websiteoss.ecoflow.com/upload/image/1761035144916/1-hide.png')}
                                        active={btnActive.c}
                                        dataId={'Water'}
                                        onChange={() => {
                                            setBtnActive({ ...btnActive, c: !btnActive.c });
                                            gtm.push({
                                                event: 'uaEvent',
                                                event_name: 'option_click',
                                                button_name: 'Water Heater_Intelligent Home Energy Management Hub',
                                                __btn_id1: `btn-item-Water`,
                                                __btn_id2: 'Water',
                                                __btn_type: 'common',
                                            });
                                        }}
                                        webpOrJpg={webpOrJpg}
                                    />
                                </SwiperSlide>
                                <SwiperSlide>
                                    <IButton
                                        url={webpOrJpg('https://websiteoss.ecoflow.com/upload/image/1758791501010/k2.png')}
                                        hideUrl={webpOrJpg('https://websiteoss.ecoflow.com/upload/image/1758791396829/g-2.png')}
                                        active={btnActive.b}
                                        dataId={'TV'}
                                        onChange={() => {
                                            setBtnActive({ ...btnActive, b: !btnActive.b });
                                            gtm.push({
                                                event: 'uaEvent',
                                                event_name: 'option_click',
                                                button_name: 'TV_Intelligent Home Energy Management Hub',
                                                __btn_id1: `btn-item-TV`,
                                                __btn_id2: 'TV',
                                                __btn_type: 'common',
                                            });
                                        }}
                                        webpOrJpg={webpOrJpg}
                                    />
                                </SwiperSlide>
                                <SwiperSlide>
                                    <IButton
                                        url={webpOrJpg('https://websiteoss.ecoflow.com/upload/image/1761035145634/3.png')}
                                        hideUrl={webpOrJpg('https://websiteoss.ecoflow.com/upload/image/1761035145178/3-hide.png')}
                                        active={btnActive.a}
                                        dataId={'Light'}
                                        onChange={() => {
                                            setBtnActive({ ...btnActive, a: !btnActive.a });
                                            gtm.push({
                                                event: 'uaEvent',
                                                event_name: 'option_click',
                                                button_name: 'Light_Intelligent Home Energy Management Hub',
                                                __btn_id1: `btn-item-Light`,
                                                __btn_id2: 'Light',
                                                __btn_type: 'common',
                                            });
                                        }}
                                        webpOrJpg={webpOrJpg}
                                    />
                                </SwiperSlide>
                            </Swiper>
                        ) : (
                            <div className="btn-list">
                                <IButton
                                    url={webpOrJpg('https://websiteoss.ecoflow.com/upload/image/1761035144634/1.png')}
                                    hideUrl={webpOrJpg('https://websiteoss.ecoflow.com/upload/image/1761035144916/1-hide.png')}
                                    active={btnActive.c}
                                    dataId={'Water'}
                                    onChange={() => {
                                        setBtnActive({ ...btnActive, c: !btnActive.c });
                                        gtm.push({
                                            event: 'uaEvent',
                                            event_name: 'option_click',
                                            button_name: 'Water Heater_Intelligent Home Energy Management Hub',
                                            __btn_id1: `btn-item-Water`,
                                            __btn_id2: 'Water',
                                            __btn_type: 'common',
                                        });
                                    }}
                                    webpOrJpg={webpOrJpg}
                                />
                                <IButton
                                    url={webpOrJpg('https://websiteoss.ecoflow.com/upload/image/1758791501010/k2.png')}
                                    hideUrl={webpOrJpg('https://websiteoss.ecoflow.com/upload/image/1758791396829/g-2.png')}
                                    active={btnActive.b}
                                    dataId={'TV'}
                                    onChange={() => {
                                        setBtnActive({ ...btnActive, b: !btnActive.b });
                                        gtm.push({
                                            event: 'uaEvent',
                                            event_name: 'option_click',
                                            button_name: 'TV_Intelligent Home Energy Management Hub',
                                            __btn_id1: `btn-item-TV`,
                                            __btn_id2: 'TV',
                                            __btn_type: 'common',
                                        });
                                    }}
                                    webpOrJpg={webpOrJpg}
                                />
                                <IButton
                                    url={webpOrJpg('https://websiteoss.ecoflow.com/upload/image/1761035145634/3.png')}
                                    hideUrl={webpOrJpg('https://websiteoss.ecoflow.com/upload/image/1761035145178/3-hide.png')}
                                    active={btnActive.a}
                                    dataId={'Light'}
                                    onChange={() => {
                                        setBtnActive({ ...btnActive, a: !btnActive.a });
                                        gtm.push({
                                            event: 'uaEvent',
                                            event_name: 'option_click',
                                            button_name: 'Light_Intelligent Home Energy Management Hub',
                                            __btn_id1: `btn-item-Light`,
                                            __btn_id2: 'Light',
                                            __btn_type: 'common',
                                        });
                                    }}
                                    webpOrJpg={webpOrJpg}
                                />
                            </div>
                        )}
                    </div>
                </li>
            </ul>
        </section>
    );
};

export default C;
